import React from "react";
import ReactCountryFlag from "react-country-flag";
import Tooltip from '@material-ui/core/Tooltip';

const CountryFlag = props => {
  if (!props.country_code) {
    return null;
  }

  return (
    <Tooltip title={props.country_name || props.country_code}>
      <span style={{ display: 'inline-flex' }}>
        <ReactCountryFlag countryCode={props.country_code} svg />
      </span>
    </Tooltip>
  );
};


export default CountryFlag;
